// extracted by mini-css-extract-plugin
export default {"form":"styles_form__pMaVs","submit":"styles_submit__4UW0I","cancel":"styles_cancel__Zh6qi"};